import i18n from "@/common/i18n";

export function getFormattedDateToHour(dateString: string): string {
  const isoString = dateString.replace(" ", "T") + "Z";
  const date = new Date(isoString);

  const currentLang = i18n.language || "en-US";

  const formattedDate = date.toLocaleDateString(currentLang, {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  const formattedTime = date.toLocaleTimeString(currentLang, {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

  return `${formattedDate} ${formattedTime}`;
}

export function formatDuration(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const hoursString = hours.toString();
  const minutesString = minutes.toString().padStart(2, "0");
  const secondsString = secs.toString().padStart(2, "0");

  return `${hoursString}:${minutesString}:${secondsString}`;
}
